import type { BillingState } from "./types";

/** What the family has now. Says nothing about a plan it has not read. */
export function subscribedLine(state: BillingState | null): string {
  if (state?.status === "trialing" && state.trial_ends_at) {
    const date = new Date(state.trial_ends_at).toLocaleDateString(undefined, { month: "long", day: "numeric" });
    return `Your free trial has started. Billing starts on ${date}, and you can cancel anytime before then.`;
  }
  if (state?.status === "active") return "Your subscription is active. Time to keep building.";
  return "Time to keep building.";
}
